module.exports = function(str){
    string_array = str.split('-');
    for(var i=0; i<string_array.length; i++){
        string_array[i] = string_array[i].charAt(0).toUpperCase() + string_array[i].slice(1);
    }
    string_array = string_array.join(" ");
    return string_array;
};